import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getTosAgreement, postUpdateTosAgreement } from "module/main/store/auth/api";
import Modal from "module/common/components/Modal";
import { selectIsAuthenticated } from "module/main/store/auth/selectors";
import { links } from "module/main/routes/utils";
var CheckTOS = function () {
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var isAuthenticated = useSelector(selectIsAuthenticated);
    useEffect(function () {
        if (isAuthenticated)
            getTosAgreement().then(function (_a) {
                var data = _a.data;
                if (!data.hasLatestTosAgreement)
                    setIsOpen(true);
            });
    }, [isAuthenticated]);
    var buttons = [
        {
            onClick: function () {
                postUpdateTosAgreement().finally(function () {
                    setIsOpen(false);
                });
            },
            name: "Accept",
        },
    ];
    return (_jsx(_Fragment, { children: _jsxs(Modal, { isOpen: isOpen, toggle: function () { return void setIsOpen(function (isOpen) { return !isOpen; }); }, isClosable: false, title: "Updated Terms of Service", buttons: buttons, children: ["Our", " ", _jsx("a", { href: links.privacy, target: "_blank", rel: "noopener noreferrer", children: "Privacy Notice" }), " ", "and", " ", _jsx("a", { href: "https://leadsherpa.freshdesk.com/support/solutions/articles/44002566512-skip-trace-api-terms-conditions", target: "_blank", rel: "noopener noreferrer", children: "Terms of Service" }), " ", "have been updated. Please review and accept them."] }) }));
};
export default CheckTOS;
